///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/decorators.ts" />
///<reference path="../../../../../vendor/misqtech/totalsuite-totalcore/assets/scripts/common/providers/settings.ts" />
namespace TotalPoll {
    import Controller = TotalCore.Common.Controller;
    import SettingsService = TotalCore.Common.Providers.SettingsService;
    import ILocationService = angular.ILocationService;
    import TabService = TotalCore.Common.Providers.TabService;

    @Controller('controllers.totalpoll')
    export class EditorCtrl {
        public information = this.SettingsService.information;
        public languages = this.SettingsService.languages;
        public modules = this.SettingsService.modules;
        public settings = this.SettingsService.settings;
        public presets = this.SettingsService.presets;

        constructor(private $rootScope, private SettingsService: SettingsService, private $location: ILocationService, private TabService: TabService) {
            let urlParams = this.$location.search();
            $rootScope.settings = this.settings;
            $rootScope.information = this.information;
            $rootScope.modules = this.modules;
            $rootScope.languages = this.languages;

            $rootScope.$applyAsync(() => {
                if (!urlParams.tab) {
                    TabService.set('editor', 'questions');
                }
            });
        }

        setTimeout(timeout) {
            this.$rootScope.settings.vote.frequency.timeout = parseInt(timeout, 10);
        }

        isCustomTimeout() {
            return ! (this.$rootScope.settings.vote.frequency.timeout in this.presets.timeout);
        }
    }

}